import init from './init'
import { LiveSpreadsheets } from './spreadsheets/LiveSpreadsheets'
import './spreadsheets/scss/global.scss'

document.addEventListener('DOMContentLoaded', () => {
    if (location?.pathname?.includes('/app/spreadsheet')) {        
        init(LiveSpreadsheets)
    }
})
